import { COMPONENT_NAME } from '@jusbrasil-web/shared-ga4-events'
import { useCallback, useEffect } from 'react'

import successImgSrc from '../../../assets/cpf-validation/success.svg'
import { COMPONENT_RENDER_EVENT_PROPS, GA4EventHandlers } from '../../../hooks'
import { DEFAULT_COURSE } from '../constants'
import { useStudentEnrollmentValidationContext } from '../context'
import { StudentEnrollmentValidationCallback } from '../types'
import { EnrollmentStaticStep } from './enrollment-static-step'

interface EnrollmentSuccessProps {
  onClose?: () => void
  gA4EventHandlers?: GA4EventHandlers
  stepsCallback?: StudentEnrollmentValidationCallback
}

export function EnrollmentSuccess(props: EnrollmentSuccessProps) {
  const { onClose, gA4EventHandlers, stepsCallback } = props
  const { texts, sharedData } = useStudentEnrollmentValidationContext()

  const title = texts?.enrollmentSuccess?.title ?? 'Matrícula verificada'
  const bodyText =
    texts?.enrollmentSuccess?.bodyText ?? 'Seu comprovante de matrícula foi verificado com sucesso.'
  const buttonText = texts?.enrollmentSuccess?.buttonText ?? 'Continuar'

  useEffect(() => {
    gA4EventHandlers?.sendComponentRender({
      componentClass: null,
      componentName: COMPONENT_NAME.DOCUMENT_VALIDATION,
      renders: COMPONENT_RENDER_EVENT_PROPS.STUDENT_ENROLLMENT_SUCCESS,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleContinue = useCallback(async () => {
    const { institution, enrollmentPeriod, course = DEFAULT_COURSE } = sharedData

    if (institution && enrollmentPeriod) {
      try {
        await stepsCallback?.(true, { institution, course, enrollmentPeriod })
      } catch (error) {
        console.error('Error running validateCallback:', error)
        return
      }
    }

    onClose?.()
  }, [onClose, sharedData, stepsCallback])

  return (
    <EnrollmentStaticStep
      testId="enrollment-success-step"
      imageSrc={successImgSrc}
      title={title}
      bodyText={bodyText}
      action={{
        onClick: handleContinue,
        label: buttonText,
      }}
      onLoadEvent={{
        name: 'UserAccount.StudentEnrollmentProofSuccessViewed',
      }}
    />
  )
}
